import React, { useEffect, useState } from "react";
import {
  CustomOutlinedDisabledCurrencyField,
  CustomOutlinedDisabledNoMarginTextField,
  CustomOutlinedDisabledTextField,
} from "../../../../../partials/content/Forms";
import { getDiscount } from "../../../../../services/sales/discountService";
import { formatDate } from "../../../../../utils/utils";
import { Checkbox } from "primereact/checkbox";
import { Card, Badge } from "react-bootstrap";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { Accordion, AccordionTab } from "primereact/accordion";
import { TabPanel, TabView } from "primereact/tabview";
import Illustration from "../../../../../partials/content/Illustration";
import { Table } from "react-bootstrap";
import { DateTime } from "luxon";
import { FormOutlinedNoMarginTextField } from "../../../../../partials/content/Forms/FormField";
import { InputAdornment } from "@material-ui/core";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";

function DiscountDetail({ match, history }) {
  const discountID = match.params.discountID;
  const [discount, setDiscount] = useState({
    discountType: 1,
    discountTypeName: "",
    minPurchaseType: 1,
    minPurchaseTypeName: "",
    discountCode: "",
    discountName: "",
    discountAmountType: 2,
    discountPercent: 0,
    discountValue: 0,
    minPurchaseAmount: 0,
    startDate: DateTime.now().startOf("day"),
    endDate: DateTime.now().endOf("day"),
    discountStatus: 0,
    discountStatusDesc: "",
    maxDiscountUse: 0,
    appliedQuot: false,
    appliedSo: false,
    appliedDs: false,
    appliedOutlet: false,
    discountOutlet: [],
    discountTriggerItem: [],
    discountFreeItem: [],
    discountAmountOffItem: [],
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [tabs, setTabs] = useState([]);
  const { reload } = useGlobalData();
  useEffect(() => {
    getDiscount(discountID).then((response) => {
      const { data } = response.data;
      setDiscount(data.discount);
      changeTabs(data.discount);
    });
  }, [discountID, reload]);

  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/sales/discount/discount-list");
      },
    },
  ];
  actionButtons.push({
    title: "Edit Discount",
    color: "primary",
    icon: "fas fa-edit",
    onClick: () => {
      history.push(`/sales/discount/discount-form/${discountID}`);
    },
  });

  return (
    <React.Fragment>
      <PageSubHeader
        title={`Discount Detail`}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/discount/discount-list",
            title: "Discounts",
            active: false,
          },
          {
            page: `/sales/discount/discount-detail/${discountID}`,
            title: "Discount ID " + discountID + " " + discount.discountName,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-window-maximize"></i>
                <span>
                  <strong>Discount Header</strong>
                </span>
                {discount.ID > 0 ? (
                  <React.Fragment>
                    <Badge
                      className="float-right ml-1"
                      variant={
                        discount.discountStatus === 2
                          ? "danger"
                          : discount.discountStatus === 1
                          ? "success"
                          : null
                      }
                    >
                      {discount.discountStatus !== 0
                        ? "Discount " + discount.discountStatusDesc
                        : null}
                    </Badge>
                  </React.Fragment>
                ) : null}
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <CustomOutlinedDisabledTextField
                      label="Discount Type"
                      value={discount.discountTypeName}
                    />
                    <CustomOutlinedDisabledTextField
                      label="Minimum Purchase Requirement"
                      value={discount.minPurchaseTypeName}
                    />
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <CustomOutlinedDisabledTextField
                          label="Discount Code"
                          value={discount.discountCode}
                        />
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <CustomOutlinedDisabledTextField
                          label="Discount Name"
                          value={discount.discountName}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-6">
                        <CustomOutlinedDisabledTextField
                          label="Start Date"
                          value={formatDate(discount.startDate)}
                        />
                      </div>
                      <div className="col-sm-12 col-md-12 col-lg-6">
                        <CustomOutlinedDisabledTextField
                          label="End Date"
                          value={formatDate(discount.endDate)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <CustomOutlinedDisabledTextField
                      label="Max Discount Use (0 unlimited)"
                      value={discount.maxDiscountUse}
                    />
                    {discount.minPurchaseType === 2 ? (
                      <CustomOutlinedDisabledCurrencyField
                        label="Min Purchase Amount"
                        value={discount.minPurchaseAmount}
                      />
                    ) : null}
                    {discount.discountType === 1 ? (
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Discount Percent"
                            value={discount.discountPercent}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledCurrencyField
                            label="Discount Value"
                            value={discount.value}
                          />
                        </div>
                      </div>
                    ) : null}
                    <div className="row mt-2">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <h5>Applied To</h5>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <div className="p-field-checkbox my-2">
                          <Checkbox
                            icon="pi pi-check-circle"
                            inputId="appliedQuot"
                            readOnly
                            disabled
                            checked={discount.appliedQuot}
                          />
                          <label htmlFor="appliedQuot">
                            <strong>Quotation</strong>
                          </label>
                        </div>
                        <div className="p-field-checkbox my-2">
                          <Checkbox
                            icon="pi pi-check-circle"
                            inputId="appliedSo"
                            readOnly
                            disabled
                            checked={discount.appliedSo}
                          />
                          <label htmlFor="appliedSo">
                            <strong>Sales Order</strong>
                          </label>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="p-field-checkbox my-2">
                          <Checkbox
                            icon="pi pi-check-circle"
                            inputId="appliedDs"
                            readOnly
                            disabled
                            checked={discount.appliedDs}
                          />
                          <label htmlFor="appliedDs">
                            <strong>Direct Sales</strong>
                          </label>
                        </div>
                        <div className="p-field-checkbox my-2">
                          <Checkbox
                            icon="pi pi-check-circle"
                            inputId="appliedOutlet"
                            readOnly
                            disabled
                            checked={discount.appliedOutlet}
                          />
                          <label htmlFor="appliedOutlet">
                            <strong>Outlet</strong>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        {tabs.length ? (
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Discount Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <div className="tabview">
                        <div className="card">
                          <TabView
                            renderActiveOnly={false}
                            className="tabview"
                            scrollable
                          >
                            {tabs.map((tab, index) => (
                              <TabPanel index={index} header={tab.title}>
                                {tab.component}
                              </TabPanel>
                            ))}
                          </TabView>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
        ) : null}
      </ContentLayout>
    </React.Fragment>
  );

  function changeTabs(discountData = null) {
    const tabsTmp = [];
    if (discountData.minPurchaseType === 1) {
      tabsTmp.push({
        title: "Trigger Items",
        component: (
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="card">
                <Table borderless size="sm" responsive="xl">
                  {discountData.discountTriggerItem &&
                  discountData.discountTriggerItem.length > 0 ? (
                    <thead className="text-center">
                      <tr>
                        <th style={{ width: "10%" }}>Combination</th>
                        <th style={{ width: "50%" }}>Item Name</th>
                        <th style={{ width: "20%" }}>Quantity</th>
                        <th style={{ width: "20%" }}>Unit</th>
                      </tr>
                    </thead>
                  ) : null}
                  <tbody>
                    {discountData.discountTriggerItem &&
                    discountData.discountTriggerItem.length > 0 ? (
                      discountData.discountTriggerItem.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td
                                style={{
                                  whiteSpace: "nowrap",
                                }}
                                className="text-center"
                              >
                                <div className="p-field-checkbox my-2">
                                  <Checkbox
                                    icon="pi pi-check-circle"
                                    inputId="binary"
                                    readOnly
                                    disabled
                                    checked={item.combineFlag}
                                  />
                                </div>
                              </td>
                              <td>
                                <FormOutlinedNoMarginTextField
                                  value={`${item.itemCode} ${item.itemName}`}
                                  InputProps={{
                                    startAdornment:
                                      item.itemType > 0 ? (
                                        <InputAdornment position="start">
                                          <BootstrapTooltip
                                            title={item.itemTypeName}
                                          >
                                            <i
                                              className={
                                                item.itemType === 1
                                                  ? "fas fa-boxes text-success"
                                                  : item.itemType === 2
                                                  ? "fas fa-tools text-primary"
                                                  : item.itemType === 3
                                                  ? "fas fa-building text-info"
                                                  : item.itemType === 4
                                                  ? "fas fa-boxes text-warning"
                                                  : item.itemType === 5
                                                  ? "fas fa-boxes text-danger"
                                                  : null
                                              }
                                            ></i>
                                          </BootstrapTooltip>
                                        </InputAdornment>
                                      ) : null,
                                    readOnly: true,
                                  }}
                                />
                              </td>
                              <td>
                                <CustomOutlinedDisabledNoMarginTextField
                                  value={item.requireQty}
                                />
                              </td>
                              <td>
                                <CustomOutlinedDisabledNoMarginTextField
                                  value={item.uomName}
                                />
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td className="text-center py-3" colSpan="4">
                          <Illustration
                            imageSource="INVIFO Sales.png"
                            guidance="You don't have any Discount Trigger items yet"
                            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                            size="sm"
                          ></Illustration>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        ),
      });
    }
    if (discountData.discountType === 2) {
      tabsTmp.push({
        title: "Free Items",
        component: (
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="card">
                <Table borderless size="sm" responsive="xl">
                  {discountData.discountFreeItem &&
                  discountData.discountFreeItem.length > 0 ? (
                    <thead className="text-center">
                      <tr>
                        <th style={{ width: "60%" }}>Item Name</th>
                        <th style={{ width: "20%" }}>Quantity</th>
                        <th style={{ width: "20%" }}>Unit</th>
                      </tr>
                    </thead>
                  ) : null}
                  <tbody>
                    {discountData.discountFreeItem &&
                    discountData.discountFreeItem.length > 0 ? (
                      discountData.discountFreeItem.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>
                                <FormOutlinedNoMarginTextField
                                  value={`${item.itemCode} ${item.itemName}`}
                                  InputProps={{
                                    startAdornment:
                                      item.itemType > 0 ? (
                                        <InputAdornment position="start">
                                          <BootstrapTooltip
                                            title={item.itemTypeName}
                                          >
                                            <i
                                              className={
                                                item.itemType === 1
                                                  ? "fas fa-boxes text-success"
                                                  : item.itemType === 2
                                                  ? "fas fa-tools text-primary"
                                                  : item.itemType === 3
                                                  ? "fas fa-building text-info"
                                                  : item.itemType === 4
                                                  ? "fas fa-boxes text-warning"
                                                  : item.itemType === 5
                                                  ? "fas fa-boxes text-danger"
                                                  : null
                                              }
                                            ></i>
                                          </BootstrapTooltip>
                                        </InputAdornment>
                                      ) : null,
                                    readOnly: true,
                                  }}
                                />
                              </td>
                              <td>
                                <CustomOutlinedDisabledNoMarginTextField
                                  value={item.qty}
                                />
                              </td>
                              <td>
                                <CustomOutlinedDisabledNoMarginTextField
                                  value={item.uomName}
                                />
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td className="text-center py-3" colSpan="3">
                          <Illustration
                            imageSource="INVIFO Sales.png"
                            guidance="You don't have any Discount Free items yet"
                            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                            size="sm"
                          ></Illustration>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        ),
      });
    }
    setTabs(tabsTmp);
  }
}
export default DiscountDetail;
